export default __webpack_public_path__ + "static/media/metro_map.76c5fbb2.png";